import { render, staticRenderFns } from "./RepairConfig.vue?vue&type=template&id=05999bb1&scoped=true"
import script from "./RepairConfig.vue?vue&type=script&lang=js"
export * from "./RepairConfig.vue?vue&type=script&lang=js"
import style0 from "./RepairConfig.vue?vue&type=style&index=0&id=05999bb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05999bb1",
  null
  
)

export default component.exports